import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, filter, fromEvent, map, Observable, Subject, takeUntil, tap } from 'rxjs';

type ValidKeyNumber = '7' | '8' | '9' | '4' | '5' | '6' | '1' | '2' | '3';
type ValidKeyLastRow = 'backspace' | '0' | '.';

type ValidKeys = ValidKeyNumber | ValidKeyLastRow;
// prettier-ignore
const numbers: readonly ValidKeyNumber[] = [
	'7', '8', '9',
	'4', '5', '6',
	'1', '2', '3'
] as const;

@Component({
	selector: 'app-mobility-calculator',
	templateUrl: './mobility-calculator.component.html',
	styleUrls: ['./mobility-calculator.component.scss'],
})
export class MobilityCalculatorComponent implements OnInit, OnDestroy {
	constructor() {}

	// prettier-ignore
	numbers = numbers;

	lastRow = ['backspace', '0', '.'] as const;

	currentNumber$ = new BehaviorSubject<string>('0');

	@Output() readonly numberChange = new EventEmitter<string>();

	@Input() resetNumber$: Observable<boolean> = new Subject<boolean>();

	destroy$ = new Subject<void>();
	ngOnInit(): void {
		this.currentNumber$.pipe(takeUntil(this.destroy$)).subscribe(val => this.numberChange.emit(val));
		this.resetNumber$.pipe(takeUntil(this.destroy$)).subscribe(val => (val ? this.currentNumber$.next('0') : null));
		this.setupKeyboardListeners();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private doesHaveDecimal(): boolean {
		return this.currentNumber$.value.includes('.');
	}
	getNumber(number: string) {
		if (this.doesHaveDecimal()) {
			this.currentNumber$.next(this.currentNumber$.value + number);
			return;
		}
		this.currentNumber$.next(String(Number(this.currentNumber$.value + number)));
	}

	getOperation(operand: string) {}

	getDecimal() {
		if (this.doesHaveDecimal()) return;
		this.currentNumber$.next(this.currentNumber$.value + '.');
	}
	clear() {
		const maxLength = Math.max(this.currentNumber$.value.length - 1, 0);
		this.currentNumber$.next(this.currentNumber$.value.slice(0, maxLength).padStart(1, '0'));
	}

	setupKeyboardListeners() {
		fromEvent<KeyboardEvent>(document, 'keydown')
			.pipe(
				map(({ key }) => key.toLowerCase() as ValidKeys),
				filter(key => this.numbers.includes(key as ValidKeyNumber) || this.lastRow.includes(key as ValidKeyLastRow)),
				takeUntil(this.destroy$),
			)
			.subscribe(key => {
				const typedKey = key as ValidKeys;
				if (this.lastRow.includes(typedKey as ValidKeyLastRow)) {
					switch (typedKey) {
						case 'backspace':
							this.clear();
							return;
						case '.':
							this.getDecimal();
							return;
						case '0':
							this.getNumber('0');
							return;
					}
					return;
				}

				this.getNumber(key);
			});
	}
}
